
export default [
	{
		"name": "Played First Game",
		"category": "Overall",
		"title": "Let the Games Begin",
		"description": "Played First Game",
		"image": "ace",
		"points": "25",
		"pushToFacebook": "true",
		"order": "1",
		"check": function (p) { return p.stats?.["win"] > 0 || p.stats?.["lose"] > 0 }
	},
	{
		"name": "5 Easy Wins",
		"category": "Easy",
		"title": "Piece of Cake",
		"description": "Win 5 matches on Easy",
		"image": "cake-slice",
		"points": "25",
		"pushToFacebook": "true",
		"order": "2",
		"check": function (p) { return p.stats?.["win_Easy"] >= 5 }
	},
	{
		"name": "5 Medium Wins",
		"category": "Medium",
		"title": "Made Flight",
		"description": "Win 5 matches on Medium",
		"image": "butterfly",
		"points": "25",
		"pushToFacebook": "true",
		"order": "3",
		"check": function (p) { return p.stats?.["win_Medium"] >= 5 }
	},
	{
		"name": "10 Medium Wins",
		"category": "Medium",
		"title": "Quick Flyer",
		"description": "Win 10 matches on Medium",
		"image": "dragonfly",
		"points": "25",
		"pushToFacebook": "true",
		"order": "4",
		"check": function (p) { return p.stats?.["win_Medium"] >= 10 }
	},
	{
		"name": "20 Medium Wins",
		"category": "Medium",
		"title": "Growing Force",
		"description": "Win 20 matches on Medium",
		"image": "bee",
		"points": "25",
		"pushToFacebook": "true",
		"order": "5",
		"check": function (p) { return p.stats?.["win_Medium"] >= 20 }
	},
	{
		"name": "50 Medium Wins",
		"category": "Medium",
		"title": "Little Fighter",
		"description": "Win 50 matches on Medium",
		"image": "wasp-sting",
		"points": "25",
		"pushToFacebook": "true",
		"order": "6",
		"check": function (p) { return p.stats?.["win_Medium"] >= 50 }
	},
	{
		"name": "100 Medium Wins",
		"category": "Medium",
		"title": "Little Champion ",
		"description": "Win 100 matches on Medium",
		"image": "scarab-beetle",
		"points": "70",
		"pushToFacebook": "true",
		"order": "7",
		"check": function (p) { return p.stats?.["win_Medium"] >= 100 }
	},
	//{
	//    "name": "Played a WIFI Game",
	//    "category": "Online",
	//    "title": "Get Connected",
	//    "description": "Played a WIFI Game",
	//    "image": "aerial-signal",
	//    "points": "25",
	//    "pushToFacebook": "true",
	//    "order": "8"
	//},
	{
		"name": "5 Hard Wins",
		"category": "Hard",
		"title": "Got Your Feet Wet",
		"description": "Win 5 matches on Hard",
		"image": "ammonite",
		"points": "25",
		"pushToFacebook": "true",
		"order": "9",
		"check": function (p) { return p.stats?.["win_Hard"] >= 5 }
	},
	{
		"name": "10 Hard Wins",
		"category": "Hard",
		"title": "Neigh to Losing",
		"description": "Win 10 matches on Hard",
		"image": "horse-head",
		"points": "25",
		"pushToFacebook": "true",
		"order": "10",
		"check": function (p) { return p.stats?.["win_Hard"] >= 10 }
	},
	{
		"name": "20 Hard Wins",
		"category": "Hard",
		"title": "Hard to Beat",
		"description": "Win 20 matches on Hard",
		"image": "turtle",
		"points": "25",
		"pushToFacebook": "true",
		"order": "11",
		"check": function (p) { return p.stats?.["win_Hard"] >= 20 }
	},
	{
		"name": "50 Hard Wins",
		"category": "Hard",
		"title": "Fast And Silent",
		"description": "Win 50 matches on Hard",
		"image": "frog",
		"points": "25",
		"pushToFacebook": "true",
		"order": "12",
		"check": function (p) { return p.stats?.["win_Hard"] >= 50 }
	},
	{
		"name": "100 Hard Wins",
		"category": "Hard",
		"title": "Choice Fish",
		"description": "Win 100 matches on Hard",
		"image": "angler-fish",
		"points": "70",
		"pushToFacebook": "true",
		"order": "13",
		"check": function (p) { return p.stats?.["win_Hard"] >= 100 }
	},
	{
		"name": "5 Crazy Ninja Wins",
		"category": "CrazyNinja",
		"title": "Ninja Has Awaken",
		"description": "Win 5 matches on CrazyNinja",
		"image": "sleepy",
		"points": "25",
		"pushToFacebook": "true",
		"order": "14",
		"check": function (p) { return p.stats?.["win_CrazyNinja"] >= 5 }
	},
	{
		"name": "10 Crazy Ninja Wins",
		"category": "CrazyNinja",
		"title": "Sparing Partner",
		"description": "Win 10 matches on CrazyNinja",
		"image": "ninja-mask",
		"points": "25",
		"pushToFacebook": "true",
		"order": "15",
		"check": function (p) { return p.stats?.["win_CrazyNinja"] >= 10 }
	},
	{
		"name": "20 Crazy Ninja Wins",
		"category": "CrazyNinja",
		"title": "Black Belt",
		"description": "Win 20 matches on CrazyNinja",
		"image": "iron-mask",
		"points": "25",
		"pushToFacebook": "true",
		"order": "16",
		"check": function (p) { return p.stats?.["win_CrazyNinja"] >= 20 }
	},
	{
		"name": "50 Crazy Ninja Wins",
		"category": "CrazyNinja",
		"title": "Merciless",
		"description": "Win 50 matches on CrazyNinja",
		"image": "tear-tracks",
		"points": "25",
		"pushToFacebook": "true",
		"order": "17",
		"check": function (p) { return p.stats?.["win_CrazyNinja"] >= 50 }
	},
	{
		"name": "100 Crazy Ninja Wins",
		"category": "CrazyNinja",
		"title": "Ninja Destroyer",
		"description": "Win 100 matches on CrazyNinja",
		"image": "pummeled",
		"points": "70",
		"pushToFacebook": "true",
		"order": "18",
		"check": function (p) { return p.stats?.["win_CrazyNinja"] >= 100 }
	},
	{
		"name": "1 Insane Monkey Win",
		"category": "Insane Monkey",
		"title": "Distinguished Warrior",
		"description": "Win 1 match on Insane Monkey",
		"image": "monkey",
		"points": "25",
		"pushToFacebook": "true",
		"order": "121",
		"check": function (p) { return p.stats?.["win_InsaneMonkey"] >= 1 }
	},
	{
		"name": "5 Insane Monkey Wins",
		"category": "Insane Monkey",
		"title": "Monkey Dominator",
		"description": "Win 5 matches on Insane Monkey",
		"image": "totem-head",
		"points": "25",
		"pushToFacebook": "true",
		"order": "122",
		"check": function (p) { return p.stats?.["win_InsaneMonkey"] >= 5 }
	},
	{
		"name": "20 Insane Monkey Wins",
		"category": "Insane Monkey",
		"title": "Monkey Dominator",
		"description": "Win 20 matches on Insane Monkey",
		"image": "totem-head",
		"points": "50",
		"pushToFacebook": "true",
		"order": "122",
		"check": function (p) { return p.stats?.["win_InsaneMonkey"] >= 20 }
	},
	{
		"name": "1 UltraCheetah Win",
		"category": "UltraCheetah",
		"title": "Hello Cheetah",
		"description": "Win 1 match on UltraCheetah",
		"image": "anthem",
		"points": "25",
		"pushToFacebook": "true",
		"order": "121",
		"check": function (p) { return p.stats?.["win_UltraCheetah"] >= 1 }
	},
	{
		"name": "10 UltraCheetah Wins",
		"category": "UltraCheetah",
		"title": "Speed Cheetah",
		"description": "Win 10 matches on UltraCheetah",
		"image": "anthem",
		"points": "50",
		"pushToFacebook": "true",
		"order": "122",
		"check": function (p) { return p.stats?.["win_UltraCheetah"] >= 10 }
	},
	{
		"name": "30 UltraCheetah Wins",
		"category": "UltraCheetah",
		"title": "Cheetah Dominator",
		"description": "Win 30 matches on UltraCheetah",
		"image": "energy-arrow",
		"points": "100",
		"pushToFacebook": "true",
		"order": "122",
		"check": function (p) { return p.stats?.["win_UltraCheetah"] >= 30 }
	},
	{
		"name": "1 Impossible Win",
		"category": "Impossible",
		"title": "Impossible Path",
		"description": "Win 1 match on Impossible",
		"image": "evil-tree",
		"points": "25",
		"pushToFacebook": "true",
		"order": "121",
		"check": function (p) { return p.stats?.["win_Impossible"] >= 1 }
	},
	{
		"name": "10 Impossible Wins",
		"category": "Impossible",
		"title": "Impossible Boom",
		"description": "Win 10 matches on Impossible",
		"image": "explosive-materials",
		"points": "50",
		"pushToFacebook": "true",
		"order": "122",
		"check": function (p) { return p.stats?.["win_Impossible"] >= 10 }
	},
	{
		"name": "30 Impossible Wins",
		"category": "Impossible",
		"title": "Not Possible",
		"description": "Win 30 matches on Impossible",
		"image": "extra-lucid",
		"points": "100",
		"pushToFacebook": "true",
		"order": "122",
		"check": function (p) { return p.stats?.["win_Impossible"] >= 30 }
	},
	{
		"name": "5 Wins",
		"category": "Overall",
		"title": "Reached Noob Status",
		"description": "Win 5 matches",
		"image": "mouse",
		"points": "25",
		"pushToFacebook": "true",
		"order": "19",
		"check": function (p) { return p.stats?.["win"] >= 5 }
	},
	{
		"name": "50 Wins",
		"category": "Overall",
		"title": "Reached Noob+ Status",
		"description": "Win 50 matches",
		"image": "mouse",
		"points": "25",
		"pushToFacebook": "true",
		"order": "19",
		"check": function (p) { return p.stats?.["win"] >= 50 }
	},
	{
		"name": "100 Wins",
		"category": "Overall",
		"title": "Small Beginnings ",
		"description": "Win 100 matches",
		"image": "mouse",
		"points": "50",
		"pushToFacebook": "true",
		"order": "20",
		"check": function (p) { return p.stats?.["win"] >= 100 }
	},
	{
		"name": "200 Wins",
		"category": "Overall",
		"title": "Consistent Flyer",
		"description": "Win 200 matches",
		"image": "bird-twitter",
		"points": "100",
		"pushToFacebook": "true",
		"order": "21",
		"check": function (p) { return p.stats?.["win"] >= 200 }
	},
	{
		"name": "300 Wins",
		"category": "Overall",
		"title": "Quiet Potential",
		"description": "Win 300 matches",
		"image": "cat",
		"points": "150",
		"pushToFacebook": "true",
		"order": "22",
		"check": function (p) { return p.stats?.["win"] >= 300 }
	},
	{
		"name": "400 Wins",
		"category": "Overall",
		"title": "Dangerous Foe",
		"description": "Win 400 matches",
		"image": "scorpion",
		"points": "200",
		"pushToFacebook": "true",
		"order": "23",
		"check": function (p) { return p.stats?.["win"] >= 400 }
	},
	{
		"name": "500 Wins",
		"category": "Overall",
		"title": "Slippery Predator ",
		"description": "Win 500 matches",
		"image": "squid",
		"points": "200",
		"pushToFacebook": "true",
		"order": "24",
		"check": function (p) { return p.stats?.["win"] >= 500 }
	},
	{
		"name": "600 Wins",
		"category": "Overall",
		"title": "Power Player",
		"description": "Win 600 matches",
		"image": "hound",
		"points": "250",
		"pushToFacebook": "true",
		"order": "25",
		"check": function (p) { return p.stats?.["win"] >= 600 }
	},
	{
		"name": "700 Wins",
		"category": "Overall",
		"title": "Quick and Formidable",
		"description": "Win 700 matches",
		"image": "lion",
		"points": "300",
		"pushToFacebook": "true",
		"order": "26",
		"check": function (p) { return p.stats?.["win"] >= 700 }
	},
	{
		"name": "800 Wins",
		"category": "Overall",
		"title": "Unstoppable Force",
		"description": "Win 800 matches",
		"image": "croc-jaws",
		"points": "300",
		"pushToFacebook": "true",
		"order": "27",
		"check": function (p) { return p.stats?.["win"] >= 800 }
	},
	{
		"name": "900 Wins",
		"category": "Overall",
		"title": "It's Dinomight!",
		"description": "Win 900 matches",
		"image": "dinosaur-rex",
		"points": "300",
		"pushToFacebook": "true",
		"order": "28",
		"check": function (p) { return p.stats?.["win"] >= 900 }
	},
	{
		"name": "1000 Wins",
		"category": "Overall",
		"title": "Soaring Above The Competition",
		"description": "Win 1000 matches",
		"image": "eagle-emblem",
		"points": "500",
		"pushToFacebook": "true",
		"order": "29",
		"check": function (p) { return p.stats?.["win"] >= 1000 }
	},
	{
		"name": "1500 Wins",
		"category": "Overall",
		"title": "King of Cards",
		"description": "Win 1500 matches",
		"image": "king",
		"points": "1000",
		"pushToFacebook": "true",
		"order": "30",
		"check": function (p) { return p.stats?.["win"] >= 1500 }
	}, {
		"name": "2000 Wins",
		"category": "Overall",
		"title": "King of Cards",
		"description": "Win 2000 matches",
		"image": "king",
		"points": "1500",
		"pushToFacebook": "true",
		"order": "30",
		"check": function (p) { return p.stats?.["win"] >= 2000 }
	},
	{
		"name": "Win Easy 5 times in a row",
		"category": "Easy",
		"title": "Dominator",
		"description": "Win Easy 5 times in a row",
		"image": "palm",
		"points": "25",
		"pushToFacebook": "true",
		"order": "31",
		"order": "30",
		"check": function (p) { return p.stats?.["win_streak_Easy"] >= 5 }
	},
	{
		"name": "Win Medium 5 times in a row",
		"category": "Medium",
		"title": "Dominator",
		"description": "Win Medium 5 times in a row",
		"image": "palm",
		"points": "25",
		"pushToFacebook": "true",
		"order": "32",
		"check": function (p) { return p.stats?.["win_streak_Medium"] >= 5 }
	},
	{
		"name": "Win Hard 5 times in a row",
		"category": "Hard",
		"title": "Dominator",
		"description": "Win Hard 5 times in a row",
		"image": "palm",
		"points": "25",
		"pushToFacebook": "true",
		"order": "33",
		"check": function (p) { return p.stats?.["win_streak_Hard"] >= 5 }
	},
	{
		"name": "Win Crazy Ninja 5 times in a row",
		"category": "CrazyNinja",
		"title": "Dominator",
		"description": "Win Crazy Ninja 5 times in a row",
		"image": "palm",
		"points": "25",
		"pushToFacebook": "true",
		"order": "34",
		"check": function (p) { return p.stats?.["win_streak_CrazyNinja"] >= 5 }
	},
	{
		"name": "Win Easy 7 times in a row",
		"category": "Easy",
		"title": "On Fire",
		"description": "Win Easy 7 times in a row",
		"image": "paw",
		"points": "25",
		"pushToFacebook": "true",
		"order": "35",
		"check": function (p) { return p.stats?.["win_streak_Easy"] >= 7 }
	},
	{
		"name": "Win Medium 7 times in a row",
		"category": "Medium",
		"title": "On Fire",
		"description": "Win Medium 7 times in a row",
		"image": "paw",
		"points": "25",
		"pushToFacebook": "true",
		"order": "36",
		"check": function (p) { return p.stats?.["win_streak_Medium"] >= 7 }
	},
	{
		"name": "Win Hard 7 times in a row",
		"category": "Hard",
		"title": "On Fire",
		"description": "Win Hard 7 times in a row",
		"image": "paw",
		"points": "25",
		"pushToFacebook": "true",
		"order": "37",
		"check": function (p) { return p.stats?.["win_streak_Hard"] >= 7 }
	},
	{
		"name": "Win Crazy Ninja 7 times in a row",
		"category": "CrazyNinja",
		"title": "On Fire",
		"description": "Win Crazy Ninja 7 times in a row",
		"image": "paw",
		"points": "25",
		"pushToFacebook": "true",
		"order": "38",
		"check": function (p) { return p.stats?.["win_streak_CrazyNinja"] >= 7 }
	},
	{
		"name": "Win Hard 10 times in a row",
		"category": "Hard",
		"title": "Overkill",
		"description": "Win Hard 10 times in a row",
		"image": "flaming-claw",
		"points": "50",
		"pushToFacebook": "true",
		"order": "39",
		"check": function (p) { return p.stats?.["win_streak_Hard"] >= 10 }
	},
	{
		"name": "Win Crazy Ninja 10 times in a row",
		"category": "CrazyNinja",
		"title": "Overkill",
		"description": "Win Crazy Ninja 10 times in a row",
		"image": "flaming-claw",
		"points": "50",
		"pushToFacebook": "true",
		"order": "40",
		"check": function (p) { return p.stats?.["win_streak_CrazyNinja"] >= 10 }
	},
	{
		"name": "Win Easy on the first draw",
		"category": "Easy",
		"title": "No Need For a Deck",
		"description": "Win Easy on the first draw",
		"image": "skeleton-inside",
		"points": "25",
		"pushToFacebook": "true",
		"order": "41",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_Level"] === "Easy" && p.sessionStats?.["lastGame_PullCount"] <= 1 }
	},
	{
		"name": "Win Medium on the first draw",
		"category": "Medium",
		"title": "No Need For a Deck",
		"description": "Win Medium on the first draw",
		"image": "skeleton-inside",
		"points": "25",
		"pushToFacebook": "true",
		"order": "42",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_Level"] === "Medium" && p.sessionStats?.["lastGame_PullCount"] <= 1 }
	},
	{
		"name": "Win Hard on the first draw",
		"category": "Hard",
		"title": "No Need For a Deck",
		"description": "Win Hard on the first draw",
		"image": "skeleton-inside",
		"points": "25",
		"pushToFacebook": "true",
		"order": "43",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_Level"] === "Hard" && p.sessionStats?.["lastGame_PullCount"] <= 1 }
	},
	{
		"name": "Win Crazy Ninja on the first draw",
		"category": "CrazyNinja",
		"title": "No Need For a Deck",
		"description": "Win Crazy Ninja on the first draw",
		"image": "skeleton-inside",
		"points": "25",
		"pushToFacebook": "true",
		"order": "44",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_Level"] === "CrazyNinja" && p.sessionStats?.["lastGame_PullCount"] <= 1 }
	},
	{
		"name": "Win Medium 5 times in one session",
		"category": "Medium",
		"title": "Going the Distance",
		"description": "Win Medium 5 times in one session",
		"image": "bird-mask",
		"points": "25",
		"pushToFacebook": "true",
		"order": "45",
		"check": function (p) {
			return p.sessionStats?.["win_Medium"] >= 5
		}
	},
	{
		"name": "Win Hard 5 times in one session",
		"category": "Hard",
		"title": "Going the Distance",
		"description": "Win Hard 5 times in one session",
		"image": "bird-mask",
		"points": "25",
		"pushToFacebook": "true",
		"order": "46",
		"check": function (p) { return p.sessionStats?.["win_Hard"] >= 5 }
	},
	{
		"name": "Win Crazy Ninja 5 times in one session",
		"category": "CrazyNinja",
		"title": "Going the Distance",
		"description": "Win Crazy Ninja 5 times in one session",
		"image": "bird-mask",
		"points": "25",
		"pushToFacebook": "true",
		"order": "47",
		"check": function (p) { return p.sessionStats?.["win_CrazyNinja"] >= 5 }
	},
	{
		"name": "Win InsaneMonkey 5 times in one session",
		"category": "InsaneMonkey",
		"title": "Going the Distance",
		"description": "Win InsaneMonkey 5 times in one session",
		"image": "bird-mask",
		"points": "25",
		"pushToFacebook": "true",
		"order": "47",
		"check": function (p) { return p.sessionStats?.["win_InsaneMonkey"] >= 5 }
	},
	{
		"name": "Win UltraCheetah 5 times in one session",
		"category": "UltraCheetah",
		"title": "Going the Distance",
		"description": "Win UltraCheetah 5 times in one session",
		"image": "bird-mask",
		"points": "25",
		"pushToFacebook": "true",
		"order": "47",
		"check": function (p) { return p.sessionStats?.["win_UltraCheetah"] >= 5 }
	},
	{
		"name": "Win Impossible 5 times in one session",
		"category": "UltraCheetah",
		"title": "Going the Distance",
		"description": "Win Impossible 5 times in one session",
		"image": "bird-mask",
		"points": "25",
		"pushToFacebook": "true",
		"order": "47",
		"check": function (p) { return p.sessionStats?.["win_Impossible"] >= 5 }
	},
	{
		"name": "Win Medium 10 times in one session",
		"category": "Medium",
		"title": "Don’t Stop Till You Get Enough",
		"description": "Win Medium 10 times in one session",
		"image": "gluttony",
		"points": "50",
		"pushToFacebook": "true",
		"order": "48",
		"check": function (p) { return p.sessionStats?.["win_Medium"] >= 10 }
	},
	{
		"name": "Win Hard 10 times in one session",
		"category": "Hard",
		"title": "Don’t Stop Till You Get Enough",
		"description": "Win Hard 10 times in one session",
		"image": "gluttony",
		"points": "50",
		"pushToFacebook": "true",
		"order": "49",
		"check": function (p) { return p.sessionStats?.["win_Hard"] >= 10 }
	},
	{
		"name": "Win Crazy Ninja 10 times in one session",
		"category": "CrazyNinja",
		"title": "Don’t Stop Till You Get Enough",
		"description": "Win Crazy Ninja 10 times in one session",
		"image": "gluttony",
		"points": "50",
		"pushToFacebook": "true",
		"order": "50",
		"check": function (p) { return p.sessionStats?.["win_CrazyNinja"] >= 10 }
	},
	{
		"name": "Lose Medium 5 times in one session",
		"category": "Medium",
		"title": "Raining On Your Parade",
		"description": "Lose Medium 5 times in one session",
		"image": "back-pain",
		"points": "50",
		"pushToFacebook": "true",
		"order": "51",
		"check": function (p) { return p.sessionStats?.["lose_Medium"] >= 5 }
	},
	{
		"name": "Lose Hard 5 times in one session",
		"category": "Hard",
		"title": "Raining On Your Parade",
		"description": "Lose Hard 5 times in one session",
		"image": "back-pain",
		"points": "50",
		"pushToFacebook": "true",
		"order": "52",
		"check": function (p) { return p.sessionStats?.["lose_Hard"] >= 5 }
	},
	{
		"name": "Lose Crazy Ninja 5 times in one session",
		"category": "CrazyNinja",
		"title": "Raining On Your Parade",
		"description": "Lose Crazy Ninja 5 times in one session",
		"image": "back-pain",
		"points": "50",
		"pushToFacebook": "true",
		"order": "53",
		"check": function (p) { return p.sessionStats?.["lose_CrazyNinja"] >= 5 }
	},
	{
		"name": "Tie Medium 1 time",
		"category": "Medium",
		"title": "Peacemaker",
		"description": "Tie Medium 1 time",
		"image": "meditation",
		"points": "50",
		"pushToFacebook": "true",
		"order": "54",
		"check": function (p) { return p.stats?.["tie_Medium"] >= 1 }
	},
	{
		"name": "Tie Hard 1 time",
		"category": "Hard",
		"title": "Peacemaker",
		"description": "Tie Hard 1 time",
		"image": "meditation",
		"points": "50",
		"pushToFacebook": "true",
		"order": "55",
		"check": function (p) { return p.stats?.["tie_Hard"] >= 1 }
	},
	{
		"name": "Tie Crazy Ninja 1 time",
		"category": "CrazyNinja",
		"title": "Peacemaker",
		"description": "Tie Crazy Ninja 1 time",
		"image": "meditation",
		"points": "50",
		"pushToFacebook": "true",
		"order": "56",
		"check": function (p) { return p.stats?.["tie_CrazyNinja"] >= 1 }
	},
	{
		"name": "Win Medium Under 60 Seconds",
		"category": "Medium",
		"title": "Slow and Steady",
		"description": "Win Medium under 60 Seconds",
		"image": "snail",
		"points": "25",
		"pushToFacebook": "true",
		"order": "57",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "Medium"
				&& p.sessionStats?.["lastGame_WinTime"] > 50
				&& p.sessionStats?.["lastGame_WinTime"] <= 60
		}
	},
	{
		"name": "Win Medium Under 50 Seconds",
		"category": "Medium",
		"title": "Quick Hands",
		"description": "Win Medium between 45-50 Seconds",
		"image": "crow-dive",
		"points": "25",
		"pushToFacebook": "true",
		"order": "58",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "Medium"
				&& p.sessionStats?.["lastGame_WinTime"] > 45
				&& p.sessionStats?.["lastGame_WinTime"] <= 50
		}
	},
	{
		"name": "Win Medium Under 45 Seconds",
		"category": "Medium",
		"title": "Crazy Fast",
		"description": "Win Medium under 45 Seconds",
		"image": "stopwatch",
		"points": "50",
		"pushToFacebook": "true",
		"order": "59",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "Medium"
				&& p.sessionStats?.["lastGame_WinTime"] <= 45
		}
	},
	{
		"name": "Win Hard Under 60 Seconds",
		"category": "Hard",
		"title": "Slow and Steady",
		"description": "Win Hard under 60 Seconds",
		"image": "snail",
		"points": "25",
		"pushToFacebook": "true",
		"order": "60",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "Hard"
				&& p.sessionStats?.["lastGame_WinTime"] <= 60
		}
	},
	{
		"name": "Win Hard Under 50 Seconds",
		"category": "Hard",
		"title": "Quick Hands",
		"description": "Win Hard between 45-50 Seconds",
		"image": "crow-dive",
		"points": "25",
		"pushToFacebook": "true",
		"order": "61",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "Hard"
				&& p.sessionStats?.["lastGame_WinTime"] > 45
				&& p.sessionStats?.["lastGame_WinTime"] <= 50
		}
	},
	{
		"name": "Win Hard Under 45 Seconds",
		"category": "Hard",
		"title": "Crazy Fast",
		"description": "Win Hard between 35-45 Seconds",
		"image": "stopwatch",
		"points": "50",
		"pushToFacebook": "true",
		"order": "62",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "Hard"
				&& p.sessionStats?.["lastGame_WinTime"] > 35
				&& p.sessionStats?.["lastGame_WinTime"] <= 45
		}
	},
	{
		"name": "Win Hard Under 35 Seconds",
		"category": "Hard",
		"title": "Crazy Fastest",
		"description": "Win Hard under 35 Seconds",
		"image": "stopwatch",
		"points": "50",
		"pushToFacebook": "true",
		"order": "62",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "Hard"
				&& p.sessionStats?.["lastGame_WinTime"] <= 35
		}
	},
	{
		"name": "Win Crazy Ninja Under 60 Seconds",
		"category": "CrazyNinja",
		"title": "Slow and Steady",
		"description": "Win Crazy Ninja between 50-60 Seconds",
		"image": "snail",
		"points": "25",
		"pushToFacebook": "true",
		"order": "63",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "CrazyNinja"
				&& p.sessionStats?.["lastGame_WinTime"] > 50
				&& p.sessionStats?.["lastGame_WinTime"] <= 60
		}
	},
	{
		"name": "Win Crazy Ninja Under 50 Seconds",
		"category": "CrazyNinja",
		"title": "Quick Hands",
		"description": "Win Crazy Ninja between 45-50 50 Seconds",
		"image": "crow-dive",
		"points": "25",
		"pushToFacebook": "true",
		"order": "64",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "CrazyNinja"
				&& p.sessionStats?.["lastGame_WinTime"] > 45
				&& p.sessionStats?.["lastGame_WinTime"] <= 50
		}
	},
	{
		"name": "Win Crazy Ninja Under 45 Seconds",
		"category": "CrazyNinja",
		"title": "Crazy Fast",
		"description": "Win Crazy Ninja between 35-45 Seconds",
		"image": "stopwatch",
		"points": "50",
		"pushToFacebook": "true",
		"order": "65",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "CrazyNinja"
				&& p.sessionStats?.["lastGame_WinTime"] > 35
				&& p.sessionStats?.["lastGame_WinTime"] <= 45
		}
	},
	{
		"name": "Win Crazy Ninja Under 35 Seconds",
		"category": "CrazyNinja",
		"title": "Crazy Fastest",
		"description": "Win Crazy Ninja under 35 Seconds",
		"image": "stopwatch",
		"points": "50",
		"pushToFacebook": "true",
		"order": "65",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "CrazyNinja"
				&& p.sessionStats?.["lastGame_WinTime"] <= 35
		}
	},
	{
		"name": "Win Insane Monkey Under 35 Seconds",
		"category": "CrazyNinja",
		"title": "Insane Fastest",
		"description": "Win Insane Monkey under 35 Seconds",
		"image": "stopwatch",
		"points": "50",
		"pushToFacebook": "true",
		"order": "65",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "InsaneMonkey"
				&& p.sessionStats?.["lastGame_WinTime"] <= 35
		}
	},
	{
		"name": "Win UltraCheetah Under 30 Seconds",
		"category": "CrazyNinja",
		"title": "UltraCheetah Fastest",
		"description": "Win UltraCheetah under 30 Seconds",
		"image": "stopwatch",
		"points": "50",
		"pushToFacebook": "true",
		"order": "65",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "UltraCheetah"
				&& p.sessionStats?.["lastGame_WinTime"] <= 30
		}
	},
	{
		"name": "Win Impossible Under 25 Seconds",
		"category": "CrazyNinja",
		"title": "Impossible Fastest",
		"description": "Win Impossible under 25 Seconds",
		"image": "stopwatch",
		"points": "50",
		"pushToFacebook": "true",
		"order": "65",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_Level"] === "Impossible"
				&& p.sessionStats?.["lastGame_WinTime"] <= 25
		}
	},
	{
		"name": "Win Any Game Under 20 Seconds",
		"category": "Any",
		"title": "Any Fastest",
		"description": "Win Impossible under 20 Seconds",
		"image": "stopwatch",
		"points": "100",
		"pushToFacebook": "true",
		"order": "65",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_WinTime"] <= 20
		}
	},
	{
		"name": "Win Any Game Under 15 Seconds",
		"category": "Any",
		"title": "Fastest Fastest",
		"description": "Win Impossible under 15 Seconds",
		"image": "stopwatch",
		"points": "150",
		"pushToFacebook": "true",
		"order": "65",
		"check": function (p) {
			return p.sessionStats?.["lastGame_Winner_isLocal"] === true
				&& p.sessionStats?.["lastGame_WinTime"] <= 15
		}
	},
	{
		"name": "Win with the '2' card",
		"category": "Other",
		"title": "Loneliest Number Next to the Number 1",
		"description": "Win with the '2' card",
		"image": "card-2-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "66",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^2[a-zA-Z]/) !== -1 }

	},
	{
		"name": "Win with the '3' card",
		"category": "Other",
		"title": "3 Times The Charm",
		"description": "Win with the '3' card",
		"image": "card-3-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "67",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^3[a-zA-Z]/) !== -1 }

	},
	{
		"name": "Win with the '4' card",
		"category": "Other",
		"title": "This is 4 You",
		"description": "Win with the '4' card",
		"image": "card-4-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "68",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^4[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the '5' card",
		"category": "Other",
		"title": "High 5",
		"description": "Win with the '5' card",
		"image": "card-5-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "69",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^5[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the '6' card",
		"category": "Other",
		"title": "6th Sense",
		"description": "Win with the '6' card",
		"image": "card-6-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "70",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^6[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the '7' card",
		"category": "Other",
		"title": "Lucky 7",
		"description": "Win with the '7' card",
		"image": "card-7-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "71",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^7[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the '8' card",
		"category": "Other",
		"title": "Behind the 8 Ball",
		"description": "Win with the '8' card",
		"image": "card-8-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "72",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^8[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the '9' card",
		"category": "Other",
		"title": "9 Lives",
		"description": "Win with the '9' card",
		"image": "card-9-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "73",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^9[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the '10' card",
		"category": "Other",
		"title": "Perfect 10",
		"description": "Win with the '10' card",
		"image": "card-10-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "74",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^10[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the 'Jack' card",
		"category": "Other",
		"title": "Jack in the Box",
		"description": "Win with the 'Jack' card",
		"image": "card-jack-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "75",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^11[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the 'Queen' card",
		"category": "Other",
		"title": "Dancing Queen",
		"description": "Win with the 'Queen' card",
		"image": "card-queen-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "76",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^12[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the 'King' card",
		"category": "Other",
		"title": "King Pin",
		"description": "Win with the 'King' card",
		"image": "card-king-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "77",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^13[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win with the 'Ace' card",
		"category": "Other",
		"title": "Ace High",
		"description": "Win with the 'Ace' card",
		"image": "card-ace-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "78",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^1[a-zA-Z]/) !== -1 }
	},
	{
		"name": "Win Medium with the 'Ace' card",
		"category": "Medium",
		"title": "Ace High",
		"description": "Win Medium with the 'Ace' card",
		"image": "card-ace-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "79",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^1[a-zA-Z]/) !== -1 && p.sessionStats?.["lastGame_Level"] === "Medium" }
	},
	{
		"name": "Win Hard with the 'Ace' card",
		"category": "Hard",
		"title": "Ace High",
		"description": "Win Hard with the 'Ace' card",
		"image": "card-ace-spades",
		"points": "25",
		"pushToFacebook": "true",
		"order": "80",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^1[a-zA-Z]/) !== -1 && p.sessionStats?.["lastGame_Level"] === "Hard" }
	},
	{
		"name": "Win Crazy Ninja with the 'Ace' card",
		"category": "CrazyNinja",
		"title": "Ace High",
		"description": "Win Crazy Ninja with the 'Ace' card",
		"image": "ace",
		"points": "25",
		"pushToFacebook": "true",
		"order": "81",
		"check": function (p) { return p.sessionStats?.["lastGame_Winner_isLocal"] === true && p.sessionStats?.["lastGame_LastCardPlayed"] != 'undefined' && p.sessionStats?.["lastGame_LastCardPlayed"]?.search(/^1[a-zA-Z]/) !== -1 && p.sessionStats?.["lastGame_Level"] === "CrazyNinja" }
	},
	{
		"name": "Block",
		"category": "Other",
		"title": "Block",
		"description": "Play a card as another player is about to play card",
		"image": "boxing-glove",
		"points": "25",
		"pushToFacebook": "true",
		"order": "82",
		"check": function (p) { return p.sessionStats?.["lastGame_blockedCount"] >= 1 }
	},
	{
		"name": "Double Block (2x)",
		"category": "Other",
		"title": "Double Block (2x)",
		"description": "Play 2 cards as another player is about to play card",
		"image": "boxing-glove",
		"points": "25",
		"pushToFacebook": "true",
		"order": "83",
		"check": function (p) { return p.sessionStats?.["lastGame_blockedCount"] === 2 }
	},
	{
		"name": "Ninja Block (3x)",
		"category": "Other",
		"title": "Ninja Block (3x)",
		"description": "Play 3 cards as another player is about to play card",
		"image": "boxing-glove",
		"points": "25",
		"pushToFacebook": "true",
		"order": "84",
		"check": function (p) { return p.sessionStats?.["lastGame_blockedCount"] === 3 }
	},
	{
		"name": "Crazy Ninja Block (4x)",
		"category": "Other",
		"title": "Crazy Ninja Block (4x)",
		"description": "Play 4 cards as another player is about to play card",
		"image": "boxing-glove",
		"points": "25",
		"pushToFacebook": "true",
		"order": "85",
		"check": function (p) { return p.sessionStats?.["lastGame_blockedCount"] === 4 }
	},
	{
		"name": "Ultra Crazy Ninja Block (5x)",
		"category": "Other",
		"title": "Ultra Crazy Ninja Block (5x)",
		"description": "Play 5 cards as another player is about to play card",
		"image": "boxing-glove",
		"points": "50",
		"pushToFacebook": "true",
		"order": "86",
		"check": function (p) { return p.sessionStats?.["lastGame_blockedCount"] === 5 }
	},
	{
		"name": "Streak (4x)",
		"category": "Other",
		"title": "Streak (4x)",
		"description": "Play 4 cards before your opponent plays a card ",
		"image": "strong",
		"points": "25",
		"pushToFacebook": "true",
		"order": "87",
		"check": function (p) { return p.sessionStats?.["lastGame_maxStreakCount"] === 4 }
	},
	{
		"name": "Great Streak (5x)",
		"category": "Other",
		"title": "Great Streak (5x)",
		"description": "Play 5 cards before your opponent plays a card ",
		"image": "strong",
		"points": "25",
		"pushToFacebook": "true",
		"order": "88",
		"check": function (p) { return p.sessionStats?.["lastGame_maxStreakCount"] === 5 }
	},
	{
		"name": "Super Streak (6x)",
		"category": "Other",
		"title": "Super Streak (6x)",
		"description": "Play 6 cards before your opponent plays a card ",
		"image": "strong",
		"points": "25",
		"pushToFacebook": "true",
		"order": "89",
		"check": function (p) { return p.sessionStats?.["lastGame_maxStreakCount"] === 6 }
	},
	{
		"name": "Crazy Streak (7x)",
		"category": "Other",
		"title": "Crazy Streak (7x)",
		"description": "Play 7 cards before your opponent plays a card ",
		"image": "strong",
		"points": "25",
		"pushToFacebook": "true",
		"order": "90",
		"check": function (p) { return p.sessionStats?.["lastGame_maxStreakCount"] === 7 }
	},
	{
		"name": "On Fire Streak (8x)",
		"category": "Other",
		"title": "On Fire Streak (8x)",
		"description": "Play 8 cards before your opponent plays a card ",
		"image": "strong",
		"points": "25",
		"pushToFacebook": "true",
		"order": "91",
		"check": function (p) { return p.sessionStats?.["lastGame_maxStreakCount"] === 8 }
	},
	{
		"name": "Ninja Streak (9x)",
		"category": "Other",
		"title": "Ninja Streak (9x)",
		"description": "Play 9 cards before your opponent plays a card ",
		"image": "strong",
		"points": "50",
		"pushToFacebook": "true",
		"order": "92",
		"check": function (p) { return p.sessionStats?.["lastGame_maxStreakCount"] === 9 }
	},
	{
		"name": "Crazy Ninja Streak (10x)",
		"category": "Other",
		"title": "Crazy Ninja Streak (10x)",
		"description": "Play 10+ cards before your opponent plays a card ",
		"image": "strong",
		"points": "50",
		"pushToFacebook": "true",
		"order": "93",
		"check": function (p) { return p.sessionStats?.["lastGame_maxStreakCount"] >= 10 }
	},
	//{
	//    "name": "Flush (4x)",
	//    "category": "Other",
	//    "title": "Flush (4x)",
	//    "description": "Play 4 cards of the same suit in a row",
	//    "image": "flush4",
	//    "points": "25",
	//    "pushToFacebook": "true",
	//    "order": "94"
	//},
	//{
	//    "name": "Great Flush (5x)",
	//    "category": "Other",
	//    "title": "Great Flush (5x)",
	//    "description": "Play 5 cards of the same suit in a row",
	//    "image": "flush5",
	//    "points": "25",
	//    "pushToFacebook": "true",
	//    "order": "95"
	//},
	//{
	//    "name": "Ninja Flush (6x)",
	//    "category": "Other",
	//    "title": "Ninja Flush (6x)",
	//    "description": "Play 6 cards of the same suit in a row",
	//    "image": "flush6",
	//    "points": "25",
	//    "pushToFacebook": "true",
	//    "order": "96"
	//},
	//{
	//    "name": "Crazy Ninja Flush (7x)",
	//    "category": "Other",
	//    "title": "Crazy Ninja Flush (7x)",
	//    "description": "Play 7 cards of the same suit in a row",
	//    "image": "flush7",
	//    "points": "50",
	//    "pushToFacebook": "true",
	//    "order": "97"
	//},
	//{
	//    "name": "Straight (4x)",
	//    "category": "Other",
	//    "title": "Straight (4x)",
	//    "description": "Play 4 cards of sequential rank",
	//    "image": "flush4",
	//    "points": "25",
	//    "pushToFacebook": "true",
	//    "order": "98"
	//},
	//{
	//    "name": "Great Straight (5x)",
	//    "category": "Other",
	//    "title": "Great Straight (5x)",
	//    "description": "Play 5 cards of sequential rank",
	//    "image": "flush5",
	//    "points": "25",
	//    "pushToFacebook": "true",
	//    "order": "99"
	//},
	//{
	//    "name": "Ninja Straight (6x)",
	//    "category": "Other",
	//    "title": "Ninja Straight (6x)",
	//    "description": "Play 6 cards of sequential rank",
	//    "image": "flush6",
	//    "points": "25",
	//    "pushToFacebook": "true",
	//    "order": "100"
	//},
	//{
	//    "name": "Crazy Ninja Straight (7x)",
	//    "category": "Other",
	//    "title": "Crazy Ninja Straight (7x)",
	//    "description": "Play 7 cards of sequential rank",
	//    "image": "flush7",
	//    "points": "50",
	//    "pushToFacebook": "true",
	//    "order": "101"
	//},
	{
		"name": "Easy - New Fastest Time",
		"category": "Easy",
		"title": "Improving Beginner",
		"description": "New fastest time on Easy",
		"image": "hourglass",
		"points": "25",
		"pushToFacebook": "true",
		"order": "102",
		"check": function (p) { return p.stats?.["win_Easy"] > 3 && p.sessionStats?.["lastGame_Level"] === "Easy" && p.sessionStats?.["lastGame_newFastestTime"] > 0 }
	},
	{
		"name": "Medium - New Fastest Time",
		"category": "Medium",
		"title": "Improving User",
		"description": "New fastest time on Medium",
		"image": "hourglass",
		"points": "25",
		"pushToFacebook": "true",
		"order": "103",
		"check": function (p) { return p.stats?.["win_Medium"] > 3 && p.sessionStats?.["lastGame_Level"] === "Medium" && p.sessionStats?.["lastGame_newFastestTime"] > 0 }
	},
	{
		"name": "Hard - New Fastest Time",
		"category": "Hard",
		"title": "Improving Expert",
		"description": "New fastest time on Hard",
		"image": "hourglass",
		"points": "25",
		"pushToFacebook": "true",
		"order": "104",
		"check": function (p) { return p.stats?.["win_Hard"] > 4 && p.sessionStats?.["lastGame_Level"] === "Hard" && p.sessionStats?.["lastGame_newFastestTime"] > 0 }
	},
	{
		"name": "Crazy Ninja - New Fastest Time",
		"category": "CrazyNinja",
		"title": "Improving Master",
		"description": "New fastest time on CrazyNinja",
		"image": "hourglass",
		"points": "25",
		"pushToFacebook": "true",
		"order": "105",
		"check": function (p) { return p.stats?.["win_CrazyNinja"] > 5 && p.sessionStats?.["lastGame_Level"] === "CrazyNinja" && p.sessionStats?.["lastGame_newFastestTime"] > 0 }
	},
	{
		"name": "5 Online Wins",
		"category": "Online",
		"title": "Online Noobie",
		"description": "Win 5 matches Online",
		"image": "duality",
		"points": "25",
		"pushToFacebook": "true",
		"order": "106",
		"check": function (p) { return p.stats?.["win_Online"] >= 5 }
	},
	{
		"name": "10 Online Wins",
		"category": "Online",
		"title": "Meeting the Competition",
		"description": "Win 10 matches Online",
		"image": "duality",
		"points": "25",
		"pushToFacebook": "true",
		"order": "107",
		"check": function (p) { return p.stats?.["win_Online"] >= 10 }
	},
	{
		"name": "20 Online Wins",
		"category": "Online",
		"title": "Beating the Competition",
		"description": "Win 20 matches Online",
		"image": "backup",
		"points": "40",
		"pushToFacebook": "true",
		"order": "108",
		"check": function (p) { return p.stats?.["win_Online"] >= 20 }
	},
	{
		"name": "50 Online Wins",
		"category": "Online",
		"title": "Plays To Win",
		"description": "Win 50 matches Online",
		"image": "backup",
		"points": "50",
		"pushToFacebook": "true",
		"order": "109",
		"check": function (p) { return p.stats?.["win_Online"] >= 50 }
	},
	{
		"name": "100 Online Wins",
		"category": "Online",
		"title": "Wifi Junkie",
		"description": "Win 100 matches Online",
		"image": "dark-squad",
		"points": "100",
		"pushToFacebook": "true",
		"order": "110",
		"check": function (p) { return p.stats?.["win_Online"] >= 100 }
	},
	{
		"name": "500 Online Wins",
		"category": "Online",
		"title": "Online Legend",
		"description": "Win 500 matches Online",
		"image": "dozen",
		"points": "50",
		"pushToFacebook": "true",
		"order": "111",
		"check": function (p) { return p.stats?.["win_Online"] >= 500 }
	},
	{
		"name": "100 Losses",
		"category": "Overall",
		"title": "Thunder Struck",
		"description": "Lose 100 matches",
		"image": "thunder-struck",
		"points": "25",
		"pushToFacebook": "true",
		"order": "112",
		"check": function (p) { return p.stats?.["lose"] > 100 }
	},
	{
		"name": "200 Losses",
		"category": "Overall",
		"title": "Eaten Right Up",
		"description": "Lose 200 matches",
		"image": "fishbone",
		"points": "25",
		"pushToFacebook": "true",
		"order": "113",
		"check": function (p) { return p.stats?.["lose"] > 200 }
	},
	{
		"name": "300 Losses",
		"category": "Overall",
		"title": "Swimming in Dangerous Waters",
		"description": "Lose 300 matches",
		"image": "shark-jaws",
		"points": "25",
		"pushToFacebook": "true",
		"order": "114",
		"check": function (p) { return p.stats?.["lose"] > 300 }
	},
	{
		"name": "400 Losses",
		"category": "Overall",
		"title": "Burned",
		"description": "Lose 400 matches",
		"image": "salamander",
		"points": "25",
		"pushToFacebook": "true",
		"order": "115",
		"check": function (p) { return p.stats?.["lose"] > 400 }
	},
	{
		"name": "500 Losses",
		"category": "Overall",
		"title": "Determined to The End",
		"description": "Lose 500 matches",
		"image": "animal-skull",
		"points": "25",
		"pushToFacebook": "true",
		"order": "116",
		"check": function (p) { return p.stats?.["lose"] > 500 }
	},


	{
		"name": "10 Insane Monkey Losses",
		"category": "Insane Monkey",
		"title": "Monkey Fighter",
		"description": "Lose 10 matches on Insane Monkey",
		"image": "monkey",
		"points": "50",
		"pushToFacebook": "true",
		"order": "123",
		"check": function (p) { return p.stats?.["lose_InsaneMonkey"] >= 10 }
	},
	{
		"name": "Rate Game",
		"category": "Other",
		"title": "Courteous Citizen",
		"description": "Rate the game",
		"image": "paw-heart",
		"points": "25",
		"order": "117"
	}
	//    ,
	//{
	//    "name": "Invite Facebook Friend",
	//    "category": "Online",
	//    "title": "Get The Party Started",
	//    "description": "Invite a facebook friend",
	//    "image": "minions",
	//    "points": "25",
	//    "order": "120"
	//}
	, {
		"name": "See More Games",
		"category": "Other",
		"title": "Dora The Explorer",
		"description": "See More Games",
		"image": "heart-inside",
		"points": "25",
		"order": "118"
	}
	, {
		"name": "Steam Game",
		"category": "Other",
		"title": "Steam Game Open",
		"description": "Welcom to Steam!",
		"image": "heart-inside",
		"points": "1500",
		"order": "125",
		"isHidden": "true",
		"check": function (p) { return p["platform"] === "Steam" }
	}

	, {
		"name": "titleTapped10",
		"category": "Easy",
		"title": "Title Tapper",
		"description": "Tap the title 10 times",
		"image": "wildfires",
		"points": "50",
		"item": "ClassicDeck",
		"order": "1",
		"check": function (p) { return p.stats?.["titleTapped"] >= 10 }
	}
	, {
		"name": "titleTapped20",
		"category": "Easy",
		"title": "Title Tapper More",
		"description": "Tap the title 20 times",
		"image": "wildfires",
		"points": "50",
		"order": "1",
		"isHidden": "true",
		"check": function (p) { return p.stats?.["titleTapped"] >= 20 }
	}
	, {
		"name": "titleTapped50",
		"category": "Medium",
		"title": "Title Tapper Extreme",
		"description": "You won the title tapping contest by tapping 50 times!",
		"image": "wildfires",
		"points": "50",
		"order": "1",
		"isHidden": "true",
		"check": function (p) { return p.stats?.["titleTapped"] >= 50 }
	}, 
	{
		"name": "titleTapped100",
		"category": "Hard",
		"title": "Title Tapper Maximum",
		"description": "There are no more Title Tapper achievements after this",
		"image": "wildfires",
		"points": "50",
		"order": "1",
		"isHidden": "true",
		"check": function (p) { return p.stats?.["titleTapped"] >= 100 }
	}, 
	{
		"name": "titleTapped200",
		"category": "Hard",
		"title": "Title Tapper Maximum",
		"description": "Fine, there was one more, but this is the last one for sure",
		"image": "wildfires",
		"points": "60",
		"order": "1",
		"isHidden": "true",
		"check": function (p) { return p.stats?.["titleTapped"] >= 200 }
	}, 
	{
		"name": "titleTapped300",
		"category": "Hard",
		"title": "Title Tapper Crazy",
		"description": "This is the absolute last one, promise!",
		"image": "wildfires",
		"points": "70",
		"order": "1",
		"isHidden": "true",
		"check": function (p) { return p.stats?.["titleTapped"] >= 300 }
	}, 
	{
		"name": "titleTapped400",
		"category": "Hard",
		"title": "Title Tapper INsaNE",
		"description": "Seriously, stop it! You broke the title!",
		"image": "wildfires",
		"points": "80",
		"order": "1",
		"isHidden": "true",
		"check": function (p) { return p.stats?.["titleTapped"] >= 400 }
	}, 
	{
		"name": "titleTapped500",
		"category": "Hard",
		"title": "Title Tapper ULTRA INsaNE",
		"description": "This is not a clicker game, stop it!",
		"image": "wildfires",
		"points": "90",
		"order": "1",
		"isHidden": "true",
		"check": function (p) { return p.stats?.["titleTapped"] >= 500 }
	}, 
	{
		"name": "titleTapped600",
		"category": "Hard",
		"title": "Title Tapper EXTREME INsaNE",
		"description": "You may want to find a real clicker game",
		"image": "wildfires",
		"points": "100",
		"order": "1",
		"isHidden": "true",
		"check": function (p) { return p.stats?.["titleTapped"] >= 600 }
	}
];
